import DeliveryOption from './DeliveryOption';

class DeliveryOptionUtility {
  static deliveryOptionEnabled(deliveryOptions: Array<DeliveryOption> | undefined, key: string): boolean {
    return DeliveryOptionUtility.getDeliveryOption(deliveryOptions, key) !== undefined;
  }

  static getDeliveryOption(
    deliveryOptions: Array<DeliveryOption> | undefined,
    key: string
  ): DeliveryOption | undefined {
    let deliveryOption: DeliveryOption | undefined = undefined;
    if (deliveryOptions !== undefined) {
      deliveryOption = deliveryOptions.find((currentDeliveryOption) => currentDeliveryOption.name === key);
    }
    return deliveryOption;
  }

  static getDeliveryOptionAndCheckExpectedValue(
    deliveryOptions: Array<DeliveryOption> | undefined,
    name: string,
    key: string,
    expectedValue: string
  ): boolean {
    return DeliveryOptionUtility.deliveryOptionHasExpectedValue(
      DeliveryOptionUtility.getDeliveryOption(deliveryOptions, name),
      name,
      key,
      expectedValue
    );
  }

  static deliveryOptionHasExpectedValue(
    deliveryOption: DeliveryOption | undefined,
    name: string,
    key: string,
    expectedValue: string
  ) {
    return (
      deliveryOption !== undefined && name === deliveryOption.name && expectedValue === deliveryOption.settings.get(key)
    );
  }

  static combineDeliveryOptions(array1: Array<DeliveryOption>, array2: Array<DeliveryOption>): Array<DeliveryOption> {
    const combinedDeliveryOptions: Array<DeliveryOption> = new Array<DeliveryOption>();
    if (array1) {
      array1.forEach((deliveryOption) => {
        combinedDeliveryOptions.push(deliveryOption);
      });
    }

    if (array2) {
      array2.forEach((deliveryOption) => {
        if (combinedDeliveryOptions.findIndex((currentOption) => currentOption.name === deliveryOption.name) === -1) {
          combinedDeliveryOptions.push(deliveryOption);
        }
      });
    }
    return combinedDeliveryOptions;
  }
}

export default DeliveryOptionUtility;
